import React,{useState} from 'react';
import {Form,Col,Container,Table} from 'react-bootstrap';


function AnswerField(props){
   
    let answers = props.answers
    const event_name = props.name.toString()
    const [value,setVal] = useState(props.data!=null?props.data:"")
    const onChange =(event) =>{
        setVal(event.target.value)
        props.handler(event)
    }
    if (props.specific_anwsers === true){
        return(
        
            <Form.Group as={Col}>
                    
                    <Form.Control as={"select"} onChange={props.handler} name={event_name} disabled={props.disabled}>
                            {answers[props.name].map((answer,index) =>(
                                <option key={index}>{answer}</option>))}
                    </Form.Control>
                 </Form.Group>
          
            )
    }
    else{
        return(
            
        <Form.Group as={Col}>
                
                <Form.Control as={"select"} onChange={onChange} name={event_name} value={value} disabled={props.disabled}>
                        {answers.map((answer,index) =>(
                            <option key={index}>{answer}</option>))}
                </Form.Control>
            </Form.Group>
    
        )
    }
}
AnswerField.defaultProps ={
    specific_anwsers:false
}

function QTable(props){
    let questions = props.questions
    return(
        <div>
              
             <Container>
                {props.title!==null && <h3 style={{textAlign:'center'}}>{props.title}</h3>}
                <br/>
                <Table responsive={true} bordered={false} size="md" hover={true} striped={false}>
                    <thead>
                       {props.subtitle!==null && <h4>{props.subtitle}</h4>}
                        <tr>
                            
                            <th>Question</th>
                            <th>Answer</th>
                        </tr>
                    </thead>
                    <tbody>
                        
                        {questions.map((items,index ) =>
                            <tr key={index}>
                                <th><p>{index+1}.{items}</p></th>
                                <th>{props.data!=null?<AnswerField name={index+1} data={props.data[index+1]}handler={props.handler} disabled={props.disabled} answers={props.answers} fieldName={props.fieldName}/>:
                                    <AnswerField name={index+1} handler={props.handler} answers={props.answers} fieldName={props.fieldName}/>
                                }</th>
                            </tr>
                        )}
                    </tbody>
                
                
                </Table>
            </Container>
            </div>
    )
}

QTable.defaultProps = {
    title:null,
    subtitle:null,
    questions:[],
    answers:[],
    handler:null,
    fieldName:'',
    data:null,
    disabled:false
}

export default QTable;